module.exports = __webpack_public_path__ + "static/img/invest-consume14.08db1e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume14.jpg
// module id = OGDz
// module chunks = 0